import { cn } from '@brew/ui/cn'
import {
  FLOW_CARD_CLASSES,
  FLOW_CARD_STRIP_CLASSES,
  FLOW_CARD_STRIP_ITEM_CLASSES,
  FLOW_GRID_CLASSES,
  TEMPLATE_CARD_CLASSES,
  TEMPLATE_CARD_PREVIEW_CLASSES,
  TEMPLATE_GRID_CLASSES,
} from '../lib/grid-classes'

const SKELETON_GRID_KEYS = Array.from(
  { length: 12 },
  (_, i) => `grid-skel-${i}`
)

/** Skeleton for the brand combobox pill leading the filter row. */
export function BrandFilterPillSkeleton() {
  return (
    <div className="h-8 w-24 shrink-0 animate-pulse rounded-lg bg-muted/30" />
  )
}

/** Matches `TemplatesSemanticSearchBar` (`h-11` dry pill) so the route loading shell does not jump. */
export function TemplatesSemanticSearchBarSkeleton() {
  return (
    <div className="h-11 w-full animate-pulse rounded-lg border border-border bg-muted/20" />
  )
}

/**
 * One gallery card: artwork box + metadata footer line, mirroring
 * `EmailPreviewCard`'s structure so the swap to real cards is
 * layout-stable.
 */
export function TemplateCardSkeleton() {
  return (
    <div className={TEMPLATE_CARD_CLASSES}>
      <div
        className={cn(
          TEMPLATE_CARD_PREVIEW_CLASSES,
          'animate-pulse bg-muted/20'
        )}
      />
      <div className="mt-3 flex w-full min-w-0 items-center gap-2.5">
        <div className="size-7 shrink-0 animate-pulse rounded-full bg-muted/30" />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="h-3.5 w-24 animate-pulse rounded bg-muted/30" />
          <div className="h-3 w-36 animate-pulse rounded bg-muted/20" />
        </div>
      </div>
    </div>
  )
}

export function GridContentSkeleton() {
  return (
    <div className={TEMPLATE_GRID_CLASSES}>
      {SKELETON_GRID_KEYS.map((key) => (
        <TemplateCardSkeleton key={key} />
      ))}
    </div>
  )
}

const FLOW_SKELETON_KEYS = Array.from({ length: 8 }, (_, i) => `flow-skel-${i}`)
const FLOW_STRIP_KEYS = [0, 1, 2] as const

/** Skeleton for one flow card: the three-up strip, then the caption line. */
export function FlowCardSkeleton() {
  return (
    <div className={FLOW_CARD_CLASSES}>
      <div className={FLOW_CARD_STRIP_CLASSES}>
        {FLOW_STRIP_KEYS.map((key) => (
          <div
            key={key}
            className={cn(FLOW_CARD_STRIP_ITEM_CLASSES, 'animate-pulse')}
          />
        ))}
      </div>
      <div className="mt-3 flex items-center gap-2.5">
        <div className="size-7 shrink-0 animate-pulse rounded-full bg-muted/30" />
        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <div className="h-3.5 w-28 animate-pulse rounded bg-muted/30" />
          <div className="h-3 w-40 animate-pulse rounded bg-muted/20" />
        </div>
      </div>
    </div>
  )
}

export function FlowsGridSkeleton() {
  return (
    <div className={FLOW_GRID_CLASSES}>
      {FLOW_SKELETON_KEYS.map((key) => (
        <FlowCardSkeleton key={key} />
      ))}
    </div>
  )
}
